//常规表单验证， 调用时需参数：验证的提示语msg
export const ruleNormal: any = (msg: string) => {
  return { required: true, message: msg, trigger: ["blur", "change"] };
};
//自定义正则验证表单， 调用时需参数：正则表达式pattern，验证的提示语msg
export const rulePattern: any = (pattern: any, msg: string) => {
  return {
    // required: true,
    pattern: pattern,
    message: msg,
    trigger: ["blur", "change"]
  };
};

// 定义一些和权限有关的 Vue指令
// 必须包含列出的所有权限，元素才显示
export const hasPermission = {
  install(Vue) {
    Vue.directive("hasPermission", {
      bind(el, binding, vnode) {
        const permissions = sessionStorage.permissions;
        if (!permissions) {
          if (!el.parentNode) {
            el.style.display = "none";
          } else {
            el.parentNode.removeChild(el);
          }
          return;
        }
        let per: any = [];
        per = JSON.parse(permissions);
        const value = binding.value;
        if (!value) return;
        let flag = true;
        for (const v of value) {
          if (!per.includes(v)) {
            flag = false;
          }
        }
        if (!flag) {
          if (!el.parentNode) {
            el.style.display = "none";
          } else {
            el.parentNode.removeChild(el);
          }
        }
      }
    });
  }
};


// zip格式
export function download(blob: Blob, name: string, cb: Function) {
  let downloadElement = document.createElement("a");
  let href = window.URL.createObjectURL(new Blob([blob])); // 创建下载的链接
  downloadElement.style.display = "none";
  downloadElement.href = href;
  downloadElement.download = `${name}`; // 下载后文件名
  document.body.appendChild(downloadElement);
  downloadElement.click(); // 点击下载
  document.body.removeChild(downloadElement); // 下载完成移除元素
  window.URL.revokeObjectURL(href); // 释放掉blob对象
  cb();
}

// 根据身份证号码 返回 年龄 生日 性别
export function computedDate(idCard) {
  let ret: any = { age: '', bornDate: '', gender: '' };
  let date: any = new Date();
  let curYear: any = date.getFullYear() - 0
  let curDate = `${date.getMonth() + 1}+""+${date.getDate() - 0}`;
  let userBornDate = idCard.slice(6, 6 + 8)
  let userYear = userBornDate.slice(0, 4) - 0
  let userDate = userBornDate.slice(4, 8)
  ret.bornDate = userYear + '-' + userDate.slice(0, 2) + '-' + userDate.slice(2, 4)
  ret.age = curYear - userYear
  var deltaDate = `${curDate} - ${(userDate - 0)}`;
  Number(deltaDate) < 0 ? ret.age-- : null;
  //     ret.gender=idCard.slice(-2)[0]%2==0?'女':'男'
  ret.gender = idCard.slice(-2)[0] % 2 == 0 ? '2' : '1'
  return ret
}

//对象键批量替换 
export function keyNameTranslate(originObj, mapArr) {
  mapArr.forEach(e => {
    let oldKey = Object.keys(e)[0]
    let newKey = Object.values(e)[0]
    //递归循环
    recursion(originObj);
    function recursion(originObj) {
      if (getType(originObj) === 'Array') {
        originObj.forEach(e => recursion(e));
        return
      };
      Object.keys(originObj).forEach(key => {
        let type = getType(originObj[key])
        if (type === 'Object' || type === 'Array') {
          recursion(originObj[key])
        }
        if (key === oldKey) {
          //值拷贝
          originObj[newKey as any] = originObj[oldKey];
          delete originObj[oldKey];
        }
      })
    }
  })

  function getType(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1)
  }
  return originObj
}

//测试
// obj = { a: 1, 
//   b: 2, 
//   c: [
//     { a: 2, c: 3 }, 
//     { a: 1, c: 4 }],
//      href: 'www.baidu.com', 
//      child: { a: 2, c: 3,
//        href: "www.google.com", 
//        child: {
//           href: ['www.123.com', 'www.321.com'],
//         d: 2, a: { b: 3, a: 'final' } 
//       } } }
//  keyNameTranslate(obj,[{a:'A'},{b:'B'}])


export function copyMemberByKey(originObj, levelKey, map) {
  //递归循环
  recursion(originObj);
  function recursion(originObj) {
    Object.keys(originObj).forEach(key => {
      let type = getType(originObj[key])
      if (type === 'Object' || key === levelKey) {
        recursion(originObj[key])
      }
      map.forEach(e => {
        if (Object.keys(e)[0] === key) {
          //值拷贝
          originObj[e[key]] = originObj[key];
        }
      })
    })
  }
  function getType(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1)
  }
  return originObj;
}

export function digui(arr, newArr) {
  arr.forEach(v => {
    if (v.isChecked == 'TRUE') {
      newArr.push(v.id)
    }
    if (v.childList != null) {
      digui(v.childList, newArr)
    }
  })
  return newArr
}